import { Component, OnInit, ViewChild, HostListener} 			  from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators}      from '@angular/forms';
import {ErrorStateMatcher}                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                 from '@angular/router';
import { first, map }                                             from 'rxjs/operators';

import { AlertService, ExamService }                     		  from '../_services';
import { Globals  }                                               from '../_helpers';
import swal,{ SweetAlertOptions }                                 from 'sweetalert2';
import { SwalComponent }                                          from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService }                                      from 'ngx-spinner';
import { DomSanitizer }                                           from '@angular/platform-browser';
import { Subject }                                                from 'rxjs';
import { Observable,throwError }                                  from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil }               from 'ngx-webcam';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}



@Component({
  	selector: 'assessor-test',
  	templateUrl: './test-page.component.html',
  	styleUrls: ['./test-viva-page.component.css'],
})

export class TestComponent implements OnInit{
    @ViewChild('optionsubmitSwal') private optionsubmitSwal: SwalComponent;
    @ViewChild('optionsubmitconfirmSwal') private optionsubmitconfirmSwal: SwalComponent;
    @ViewChild('examsubmitconfirmSwal') private examsubmitconfirmSwal: SwalComponent;
    @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
    @ViewChild('noanyanswerSwal') private noanyanswerSwal: SwalComponent;
    
    public alertOption:SweetAlertOptions = {};

    matcher = new MyErrorStateMatcher();

    @HostListener('window:keyup', ['$event']) 
    onKeyupHandler(event: KeyboardEvent) {
        if(event.keyCode == 123 || event.keyCode == 122)
            this.autoSubmitAnswers();
        event.stopPropagation();
    }

    studentName: string = '';
    studentCode: string = '';
	optionIndexText = ['A','B','C','D','E','F','G','H','I','J'];
    answerdObj = {};
    notSubmitObj = [];
    answeredQuestObj = [];
	questArr = [];
	loading = false;
    indexClasses: string;
	timershow: string;
    returnUrl: string;
    maxMarks : number;
    duration : number = 0;
    type : string;
    totalQuestion: number;
    question : string;
    questionInst: string;
    index : number = 1;
    answer_id: number;
    ssclogo: string = '';
    deficulty_lebel: number = 0;
    userData = {};
    settings = {};
    options = [];
    distance:any;
    totalAnswered:number = 0;
    totalSubmited:number = 0;
    totalVisited:number = 0;
    totalNotAnswered:number = 0;
    interval;
    settime;
    isPause = false;
    visitedQuesObj = {};
    isSubmit = false;
    isPauseBtn = false;

    isMedia = false;
    qaudioUrl: string = ''; 
    qvideoUrl: string = '';
    qimageUrl: string = '';
    isPicTaken;
    imagePath;
    noofpic:number = 0;   

    /* Chart Variable */
    public pieChartLabels:string[] = ['Answered', 'Submitted', 'Visitted', 'Not attempted'];
    public pieChartData:number[] = [];
    public pieChartType:string = 'pie';
    public pieChartLegend = false;
    public chartColors: any[] = [{ 
        backgroundColor:["#44e51e", "#FF7272", "#ce03dc", "#c4c4c4"] 
    }];

    /* webcam Settings */
    public showWebcam = true;
    public allowCameraSwitch = true;
    public multipleWebcamsAvailable = false;
    public deviceId: string;

    public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
    };
    public errors: WebcamInitError[] = [];

    // latest snapshot
    public webcamImage: WebcamImage = null;

    // webcam snapshot trigger
    private trigger: Subject<void> = new Subject<void>();

    // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
    private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();


	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private examService: ExamService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private domSanitizer: DomSanitizer
    ) { }

    ngOnInit() {
        this.requestFullscreen(document.documentElement);

    	this.userData = JSON.parse(localStorage.getItem('currentUser'));
    	this.settings = this.userData['settings'];
        this.studentName = this.userData['name'];
        this.studentCode = this.userData['code'];
        if(this.settings['submit'] == 0)
            this.isSubmit = true;
        if(this.settings['student_pause'] == 0){
            this.isPauseBtn = true;
        }
        if(this.settings['exam_logo'] != ""){
            this.ssclogo = this.settings['exam_logo'];
        }

    	/* call function for first question and exam info */
 		this.getExams();

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        WebcamUtil.getAvailableVideoInputs()
        .then((mediaDevices: MediaDeviceInfo[]) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
    }

    public triggerSnapshot(): void {
        this.trigger.next();
        this.imagePath = this.webcamImage.imageAsDataUrl;
        this.isPicTaken = false;
    }

    public toggleWebcam(): void {
        this.showWebcam = !this.showWebcam;
    }

    public handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
    }

    public showNextWebcam(directionOrDeviceId: boolean|string): void {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    }

    public handleImage(webcamImage: WebcamImage): void {
        this.webcamImage = webcamImage;
    }

    public cameraWasSwitched(deviceId: string): void {
        this.deviceId = deviceId;
    }

    public get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }

    public get nextWebcamObservable(): Observable<boolean|string> {
        return this.nextWebcam.asObservable();
    }

    public webCameScreen(): void{
        this.isPicTaken = true;
    }

    /* Get Exam data when exam UI is load */
    private getExams(){
    	this.loading = true;
        this.spinner.show();
    	this.options = [];
    	this.questArr= [];
        this.answerdObj = {};
        this.isMedia = false;
        this.qaudioUrl = ''; 
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.examService.getFirstQuestion(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    let exam = data.exams;
                    this.maxMarks = exam.max_marks;
                    this.duration = exam.duration;
                    this.type = exam.type;
                    this.totalQuestion = exam.totalq;
                    let questionData = exam.question;
                    this.answer_id = 0;
                    this.question = questionData.question;
                    this.questionInst = questionData.question_inst;

                    if(questionData.media != ''){
                        this.isMedia = true;
                        if(questionData.media_type == 2){
                            this.qimageUrl = questionData.media;
                        }
                        else if(questionData.media_type == 3){
                           this.qaudioUrl = questionData.media; 
                        }
                        else if(questionData.media_type == 4){ 
                            this.qvideoUrl = questionData.media;
                        }
                    }

                    /* Create Option obj */
                    this.createOptionsObj(questionData.options);

                    /* Create array for question index */ 
                    this.createArrayQuesNoObj(this.totalQuestion);

                    /* Set counter */
                    this.counter(exam.duration);

                    /* set button background color */
                    this.btnStyle(1, 'current');

                    this.takePicWithTimer(this.duration/ 6);
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
        );
    }

    /* Get Exam data by index number */
    private getQuestionByIndex(){
    	this.options = [];
    	this.loading = true;
        this.isMedia = false;
        this.qaudioUrl = ''; 
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.spinner.show();
        this.examService.getQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.deficulty_lebel)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    let questionData = data.question;
            
                    this.question = questionData.question;
                    this.questionInst = questionData.question_inst;

                    if(questionData.media != ''){
                        this.isMedia = true;
                        if(questionData.media_type == 2){
                            this.qimageUrl = questionData.media;
                        }
                        else if(questionData.media_type == 3){
                           this.qaudioUrl = questionData.media; 
                        }
                        else if(questionData.media_type == 4){ 
                            this.qvideoUrl = questionData.media;
                        }
                    }

                    this.createOptionsObj(questionData.options);

                    if(this.index in this.answerdObj){
                        this.answer_id = this.answerdObj[this.index];
                        this.optBtnStyle(this.answer_id, this.index);
                        this.btnStyle(this.index, 'answered');
                    }
                    else{
                        this.btnStyle(this.index, 'current');
                    }
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
        );
    }

    /* Create array of object for number of question and lebel */
    private createArrayQuesNoObj(totalQuest){
    	for (var i = 0; i < totalQuest; ++i) {
    		this.questArr[i] = {index: i+1};
    	}
    }

    /* Create question option array */
    private createOptionsObj(options){
    	for (var i = 0; i < options.length; ++i) {
    		this.options[i] = {optiontext: options[i].option, id: options[i].option_id};
    	}
        this.spinner.hide();
    }

    /* On index click get this question */
    public getQuestionIndex(event, item){
        if(!this.isPause && this.visitedQuesObj[item] != 'submited'){
        	this.index = item;
        	this.getQuestionByIndex();
            this.visitedQuesObj[this.index] = 'visited';
        }
    }

    /* On click previous button get question */
    public prevQuestion(){
    	if(this.index > 1 && !this.isPause){
            let curind =  this.getNextIndex('prev', this.index - 1);
            console.log(curind);
	    	this.index = curind;
	    	this.getQuestionByIndex();
            this.visitedQuesObj[this.index] = 'visited';
	    }
    }

    /* On click next button get question */
    public nextQuestion(){
    	if(this.index < this.totalQuestion && !this.isPause){
            let curind =  this.getNextIndex('next', this.index + 1);
            this.index = curind;
	    	this.getQuestionByIndex();
            this.visitedQuesObj[this.index] = 'visited';
	    }
        else if(!this.isPause){
            this.openSubmitArea();
        }
    }

    /* On click pouse button stop timer */
    public pauseExam(){
        if(this.settings['student_pause'] == 1){
            let status = '';
            if(this.isPause){
                this.isPause = false;
                status = 'resume';
            }
            else{
                this.isPause = true;
                status = 'pause';
            }
            this.spinner.show();
            this.examService.setExamPauseResume(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], status)
            .pipe(first())
            .subscribe(
                data => {
                    console.log(data)
                    if(data.code == 1000){

                    }
                    else{
                        this.loading = false;
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                    //this.router.navigateByUrl('/login');
                }
            );
        }
    }

    /* Exam option select event */
    public optionSelected(event, indx){
        if(!this.isPause){
            var allOption = document.getElementsByClassName('option-btn-style');
            if(typeof allOption != 'undefined' && allOption.length > 0){
                for (var i = 0; i < allOption.length; ++i) {
                    /*allOption[i].classList.add('isUnchecked');*/
                    allOption[i].classList.remove('isChecked');
                }
            }

            var currentOption = event.target;
            currentOption.classList.add('isChecked');

            this.btnStyle(this.index, 'answered');

            /*set Answer id */
            this.answer_id = indx;

            /*set answer with question */
            this.answerdObj[this.index] = this.answer_id;
            this.notSubmitObj.push({index:this.index, answer_id:this.answer_id});
            this.visitedQuesObj[this.index] = 'answered';
        }
    }

    /* On click submit button submit current index answer */
    public submitQuestion(){
        if(!this.isPause){
            if(this.answer_id > 0){
                this.optionsubmitconfirmSwal.show();
            }
            else{
                this.optionsubmitSwal.show();
            }
        }
    }

    /* submit single question */
    public submitSingleQuestion(){
        this.loading = true;
        this.spinner.show();
        this.examService.setQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.answer_id)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    this.btnStyle(this.index, 'submited');
                    this.visitedQuesObj[this.index] = 'submited';
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
        );
    }

    /* Change button color according to action */
    private btnStyle(btnIndex, status){
        setTimeout( function(){
            var currentBtn = document.getElementById('btn-'+btnIndex);
            if(typeof currentBtn != 'undefined'){
                if(status == 'answered'){
                    currentBtn.classList.add('btn-answered');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if(status == 'submited'){
                    currentBtn.classList.add('btn-submited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if(status == 'visited'){
                    currentBtn.classList.add('btn-visited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited');
                }
                else if(status == 'current'){
                    var preBtn = document.getElementsByClassName('visited-btn');
                    if(typeof preBtn != 'undefined' && preBtn.length > 0){
                        for (var i = 0; i < preBtn.length; ++i) {
                            preBtn[i].classList.add('btn-visited');
                            preBtn[i].classList.remove('btn-current');
                            preBtn[i].classList.remove('btn-answered');
                            preBtn[i].classList.remove('btn-notvisited');
                            preBtn[i].classList.remove('visited-btn');
                        }
                    }
                    
                    currentBtn.classList.add('visited-btn');
                    currentBtn.classList.add('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited'); 
                }
                else if(status == 'not-answered'){
                    currentBtn.classList.add('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                }
            }
        }, 200);
    }

    /* Change option btn color */
    private optBtnStyle(btnIndex, indexId){
        setTimeout(function(){
            var currentOptBtn = document.getElementById('op-'+btnIndex);
            if(typeof currentOptBtn != 'undefined'){
                currentOptBtn.classList.add('isChecked');
                currentOptBtn.classList.remove('isUnchecked');
            }
        }, 200);
    }

    /* Create timer according to duration */
    private counter(duration){
        var minutes = parseInt(duration);
        var seconds = 0;

        this.interval = setInterval(() => {

           if(!this.isPause){
                --seconds;
                minutes = (seconds < 0) ? --minutes : minutes;
                  
                seconds = (seconds < 0) ? 59 : seconds;

                if(minutes == 5 && seconds == 0){
                   document.getElementById('timer-id').classList.add('blink_me'); 
                }

                if(minutes <= 0 && seconds <= 0){
                    clearInterval(this.interval);
                    this.timeoverSwal.show();
                    this.settime = setTimeout(function(){
                        this.timeoverSwal.hide();
                        this.submitFinalExam();
                    }, 200);
                }

                this.timershow = minutes+':'+seconds;
            }
        },1000);
    }

    /* Pie chart */
    public openSubmitArea() {
        let visitedq = 0;
        let submitedq = 0;
        let answerdq = 0;
        let notAttemptq = 0;
        if(Object.keys(this.visitedQuesObj).length > 0){
            let ansobj = this.visitedQuesObj;
            let keyLength = Object.keys(this.visitedQuesObj).length;
            for (var i = 0; i < keyLength; ++i) {
                if(ansobj[i] == 'submited')
                    submitedq++;
                else if(ansobj[i] == 'visited')
                    visitedq++;
                else if(ansobj[i] == 'answered')
                    answerdq++;
            }

            notAttemptq = this.totalQuestion - (submitedq + visitedq + answerdq);
        }
        else{
            notAttemptq = this.totalQuestion;
        }

        this.pieChartData = [answerdq, submitedq, visitedq, notAttemptq];
        this.totalAnswered = answerdq;
        this.totalSubmited = submitedq;
        this.totalVisited = visitedq;
        this.totalNotAnswered = notAttemptq;

        document.getElementById('question-area').style.display = 'none';
        document.getElementById('submited-area').style.display = 'block';

    }

    public submitFinalAnswer(){
        this.examsubmitconfirmSwal.show();
    }

    public submitFinalExam(){
        this.loading = true;
        if(Object.keys(this.answerdObj).length > 0){
            this.autoSubmitAnswers();
        }
        else{
            this.noanyanswerSwal.show();
        }
    }

    public autoSubmitAnswers(){
        var answers = [];
        var students = [{
            student_id: this.userData['id'],
            answers: this.notSubmitObj
        }];

        var studentsStr = JSON.stringify(students);
        this.spinner.show();
        this.examService.setQuestionAnswer(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], studentsStr)
        .pipe(first())
        .subscribe(
            data => {
                console.log(data)
                if(data.code == 1000){
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
                //this.router.navigateByUrl('/login');
            }
        );

    }

    public backFromFinalSubmit(){
        document.getElementById('question-area').style.display = 'block';
        document.getElementById('submited-area').style.display = 'none';
    }

    /* Onclick reset btn */
    public resetAnswer(){
        if(!this.isPause){
            var removeIndex = this.index;
   
            this.notSubmitObj = this.notSubmitObj.filter(function( obj ) {
                if(typeof removeIndex != 'undefined')
                    return obj.index !== removeIndex;
            });
           
            var allOption = document.getElementsByClassName('option-btn-style');
            if(typeof allOption != 'undefined' && allOption.length > 0){
                for (var i = 0; i < allOption.length; ++i) {
                    allOption[i].classList.remove('isChecked');
                }
            }
            this.btnStyle(this.index, 'current');
        }
    }

    // events
    public chartClicked(e:any):void {
        console.log(e);
    }
 
    public chartHovered(e:any):void {
        console.log(e);
    }

    /* Check Submitted question and jump to next */
    private getNextIndex(type, index){
        let questDb = this.visitedQuesObj;
        if(Object.keys(this.visitedQuesObj).length < 1){
            return index;
        }
        else if(type == 'next') {
            for (var i = index; i < this.totalQuestion; ++i) {
                if(questDb[i] != 'submited')
                   return i;
            }
            if(index != 1)
                return index;
            else
                return index - 1;
        }
        else if(type == 'prev'){
            for (var i = index; i > 0; --i){
                if(questDb[i] != 'submited')
                   return i;
            }
            return index + 1;
        }
    }

    /* Go to full screen */
    public requestFullscreen(ele) {
        if (ele.requestFullscreen) {
            ele.requestFullscreen();
        } else if (ele.webkitRequestFullscreen) {
            ele.webkitRequestFullscreen();
        } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
        } else if (ele.msRequestFullscreen) {
            ele.msRequestFullscreen();
        } else {
            console.log('Fullscreen API is not supported.');
        }
    };

    /* Text to speech */
    public textToSpeech(){
        let speechHtml = this.question+'. \n';
        for (var i = 0; i < this.options.length; ++i) {
            speechHtml += this.optionIndexText[i]+' ? ';
            speechHtml += this.options[i].optiontext+'. \n';
        }
        speechSynthesis.cancel();
        var msg = new SpeechSynthesisUtterance();
        var voices = window.speechSynthesis.getVoices();
        msg.voice = voices[82]; // Note: some voices don't support altering params
        msg.volume = 1; // 0 to 1
        msg.rate = 0.8; // 0.1 to 10
        msg.pitch = 0; //0 to 2
        msg.text = speechHtml;
        msg.lang = 'en-GB'; //hi-IN hindi india.

        msg.onend = function(e) {
            speechSynthesis.cancel();
          //console.log('Finished in seconds.');
        };

        speechSynthesis.speak(msg);
    }

    /* Take photo continiously */
    public takePicWithTimer(piceDuration){
        if(this.noofpic <= 6){
            var minutes = piceDuration;
            var seconds = 0;
            this.interval = setInterval(() => {
               if(!this.isPause){
                    --seconds;
                    minutes = (seconds < 0) ? --minutes : minutes;
                      
                    seconds = (seconds < 0) ? 59 : seconds;

                    if(minutes <= 0 && seconds <= 0){
                        this.triggerSnapshot();
                        clearInterval(this.interval);
                        this.savePreExamImage();
                    }
                }
            },1000);
        }
    }

    public savePreExamImage(){
        this.examService.saveExamPic(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 'web' , this.webcamImage.imageAsDataUrl)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    this.noofpic++;
                    this.takePicWithTimer( this.duration / 6 );
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                else{
                    this.loading = false;
                }
                
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            }
        );
    }

}
